import { ConfigTab } from "../types";

export enum TAB_VIEW {
  TAM = 0,
  SAM = 1,
  SOM = 2,
}

export const TAB_VIEW_NAME_MAP = {
  0: "TAM",
  1: "SAM",
  2: "SOM",
};

export const TABS = [
  {
    id: "tam-tab",
    label: "TAM",
    tooltip:
      "What is TAM? Your Total Addressable Market is the maximum revenue opportunity if you could sell to every potential customer worldwide with no constraints.\n\nExample: If you're building a CRM like Salesforce, your TAM would include all global spending on customer relationship management software across every industry and company size.",
  },
  {
    id: "sam-tab",
    label: "SAM",
    tooltip:
      "What is SAM? Your Serviceable Available Market narrows your TAM to the customers you can actually reach and serve given your current capabilities and strategy.\n\nExample: If you're a CRM company that only serves financial services companies in North America, your SAM would be financial services spending on CRM software in the US and Canada—much smaller than your global TAM.",
  },
  {
    id: "som-tab",
    label: "SOM",
    tooltip:
      "What is SOM? Your Serviceable Obtainable Market is the slice of your SAM that you can actually win based on your company size, budget, sales capacity, and competitive advantages.\n\nExample: If you're a new CRM startup competing against Salesforce in financial services, your SOM might focus on smaller banks ($10M-$500M revenue) that find Salesforce too complex and expensive—a specific, winnable segment.",
  },
];

export const MODAL_HEADER_TITLE = "Project Configuration";
export const MODAL_HEADER_DESCRIPTION = "Configuring Your Project";
export const MODAL_HEADER_SUBDESCRIPTION = `Set up your project by completing the sections below. Define your TAM, SAM, and SOM to establish market boundaries, upload your customer list to identify whitespace opportunities, and specify competitors to track market dynamics. These inputs will power all visualizations and insights`;

// Bi-directional mappings between tab names and indexes for consistent navigation
export const TAB_TO_INDEX = {
  [ConfigTab.MARKET_SIZING]: 0,
  [ConfigTab.WHITESPACE]: 1,
  [ConfigTab.COMPETITORS]: 2,
  [ConfigTab.SETTINGS]: 3,
};

export const INDEX_TO_TAB = {
  0: ConfigTab.MARKET_SIZING,
  1: ConfigTab.WHITESPACE,
  2: ConfigTab.COMPETITORS,
  3: ConfigTab.SETTINGS,
};
